export default __webpack_public_path__ + "static/media/img2.e6ebcce6.png";